var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8821 12.2309C24.8821 10.6489 23.7184 9.37621 22.2805 9.37621C20.3329 9.28516 18.3465 9.25 16.3166 9.25H15.6838C13.6588 9.25 11.669 9.28516 9.72131 9.37656C8.28693 9.37656 7.12326 10.6562 7.12326 12.2383C7.03537 13.4895 6.9981 14.7411 7.00021 15.9926C6.9967 17.2442 7.03654 18.4969 7.11975 19.7508C7.11975 21.3329 8.28342 22.6161 9.71779 22.6161C11.7639 22.711 13.8627 22.7532 15.9967 22.7496C18.1342 22.7567 20.2272 22.7121 22.2756 22.6161C23.7135 22.6161 24.8772 21.3329 24.8772 19.7508C24.9615 18.4957 25.0002 17.2442 24.9967 15.9891C25.0047 14.7375 24.9665 13.4848 24.8821 12.2309ZM14.2776 19.4414V12.5332L19.3752 15.9856L14.2776 19.4414Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/Yt.d6d4a0fbcbd326d9c53aa529f566e07d.svg";
export { ForwardRef as ReactComponent };